import { FaWhatsapp } from "react-icons/fa";

const FloatingWhatsAppButton = () => {
  const phone = "+919220198202";
  const message = encodeURIComponent("Hi Tripocation Holiday Pvt. Ltd., I want to get more details");
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phone}&text=${message}&app_absent=0`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg z-50"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={20} />
    </a>
  );
};

export default FloatingWhatsAppButton;
